module.exports = __webpack_public_path__ + "img/device_mouse.5fcd8760.png";